import { Button, message } from "antd";
import { YhBox } from "@/components/YhBox";
import { accountDataModel } from "./accountDataModel";
import { AccountDataTable } from "./AccountDataTable";
import { AccountSearchBox } from "./AccountSearchBox";
import { AdjustMonthDrawer } from "./AdjustMonthDrawer";
import { RechargeDrawer } from "./RechargeDrawer";

export const AccountDataBox = () => {

    const {
        selectedRowKeys,
        setAdjustMonthDrawerVisible,
        setRechargeDrawerVisible,
    } = accountDataModel();

    const adjust = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setAdjustMonthDrawerVisible(true);
        } else {
            message.error("请选择记录!");
        }
    }

    const onRecharge = () => {
        if (selectedRowKeys && selectedRowKeys.length > 0) {
            setRechargeDrawerVisible(true);
        } else {
            message.error("请选择充值账户!");
        }
    }

    const action = (
        <div>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={adjust}
            >调额</Button>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                onClick={onRecharge}
            > 充值</Button>
        </div >
    );

    return (
        <>
            <AccountSearchBox />
            <YhBox title={action} >
                <AccountDataTable />
            </YhBox>
            <AdjustMonthDrawer />
            <RechargeDrawer />
        </>
    )
}
